import Axios from '../axios'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'
import { ISupportDataSsp } from '../../interfaces/i-api-support'
import appConfig from '../../../app.config'

async function sendEmailSspService(email: ISupportDataSsp) {
	const { data } = await Axios.post(
		`${appConfig.customerDataBaseUrl}/api/support/ssp/email`,
		email,
		await getHeadersWithJwtToken()
	)
		.then((res) => {
			return res
		})
		.catch((err) => {
			logError(err)
			throw new Error(err)
		})
	return data
}

export default sendEmailSspService
